import { render } from "./NewOrderPay.vue?vue&type=template&id=22573425&scoped=true"
import script from "./NewOrderPay.vue?vue&type=script&lang=js"
export * from "./NewOrderPay.vue?vue&type=script&lang=js"

import "./NewOrderPay.vue?vue&type=style&index=0&id=22573425&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22573425"]])

export default __exports__